import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import CreateShop from '@/components/common/CreateShop.vue'
import Header from '@/views/layout/Header.vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const visible = computed(() => store.state.status.toCreateShop)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_scrollbar, { height: "100%" }, {
      default: _withCtx(() => [
        _createVNode(Header),
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    (_unref(visible))
      ? (_openBlock(), _createBlock(CreateShop, {
          key: 0,
          modelValue: _unref(visible),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).commit('status/toCreateShop', false))),
          onOk: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).dispatch('route/updateUser')))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})